import { CheckRound, ClockOutlined, InfoOutlined, RoundExclam } from '@ori-ui/icons';
import React from 'react';
const MuiAlert = {
  variant: 'filled',
  iconMapping: {
    error: /*#__PURE__*/React.createElement(RoundExclam, null),
    info: /*#__PURE__*/React.createElement(InfoOutlined, null),
    success: /*#__PURE__*/React.createElement(CheckRound, null),
    warning: /*#__PURE__*/React.createElement(ClockOutlined, null)
  }
};
export default MuiAlert;